import { ButtonVariant } from '@/shared/components/Buttons';
import type { UpdateStatusDialogProps } from '@/epics/adminManagment/pages/adminList/UpdateStatusDialog';
import { SUBSCRIPTION_MANAGEMENT_LABELS } from '@/epics/subscriptionManagment/constants/translations/labels';
import {
  EditSubscriptionPlanWarningDescription,
  EditSubscriptionPlanWarningIcon,
} from './EditSubscriptionPlanWarningDialogContent';

export type EditSubscriptionPlanWarningDialogConfig = Pick<
  UpdateStatusDialogProps,
  | 'title'
  | 'content'
  | 'confirmButtonLabel'
  | 'icon'
  | 'confirmButtonVariant'
  | 'cancelButtonLabel'
>;

export function getEditSubscriptionPlanWarningDialogConfig(
  activeClientCount: number
): EditSubscriptionPlanWarningDialogConfig {
  return {
    title: SUBSCRIPTION_MANAGEMENT_LABELS.HEADING_EDIT_PLAN_CONFIRM.polish,
    content: (
      <EditSubscriptionPlanWarningDescription
        activeClientCount={activeClientCount}
      />
    ),
    confirmButtonLabel:
      SUBSCRIPTION_MANAGEMENT_LABELS.BUTTON_CONTINUE_EDITING.polish,
    cancelButtonLabel: SUBSCRIPTION_MANAGEMENT_LABELS.BUTTON_CANCEL.polish,
    icon: <EditSubscriptionPlanWarningIcon />,
    confirmButtonVariant: ButtonVariant.Primary,
  };
}
